import { XIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DrawerClose } from '@/components/ui/drawer';

const DrawerMobileClose = () => (
  <DrawerClose asChild>
    <Button variant="outline" size="icon" className="shrink-0 sm:hidden" aria-label="Close">
      <XIcon />
    </Button>
  </DrawerClose>
);

export default DrawerMobileClose;
